class AbstractSitesService {
  allSite = { key: "all", name: "All" };
  defaultSites = [this.allSite, { key: "website", name: "Website" }];

  processSitesResponse(response) {
    const fetchedSites = [this.allSite];
    for (let { SiteName: siteName, ItemName: siteKey } of response) {
      fetchedSites.push({ key: siteKey, name: siteName });
    }
    return fetchedSites;
  }
}

export default AbstractSitesService;



// WEBPACK FOOTER //
// ./src/data/AbstractSitesService.js